app.controller('errorAccessDeniedController', ['$scope', '$state', 'objectHelper', 'applicationModel',
    function ($scope, $state, objectHelper, applicationModel) {

        function setData() {
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
        }

        function configureInterface() {
            applicationModel.deselectSideBarItems();

            var breadcrumbItems = [
                objectHelper.o(EsBreadcrumbItem, { name: 'T.UI.BREADCRUMB.ERROR', state: Constant.STATE.APP.ERROR.ACCESS_DENIED })
            ];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.SYSTEM.ERROR.ERROR');
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
